// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editNameContainer {
    width: 90%;
    padding-left: 4vw;
    padding-top: 5vh;
    display: flex;
    flex-direction: column;
    gap: 5vh;
    padding-bottom: 30px;
}

.uploadIdContainer {
    border-radius: 20px;
    background: #0E1B1B;
    padding-left: 2vw;
    box-sizing: border-box;
    width: 90%;
    padding-top: 30px;
    padding-bottom: 30px;
}

.uploadIdContainer2 {
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.10);
    backdrop-filter: blur(25.989974975585938px);
    width: 92%;
    padding-left: 30px;
    padding-top: 30px;
    padding-bottom: 30px;
    margin-top: 2vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 18vh;
    gap: 1vh;
}

.uploadIconContainer {
    background-color: #4DCBCA;
    border-radius: 10px;
    padding: 10px 25px;
}
.uploadImage{
    width: 20px;
    height: 20px;
}
.uploadIdBtnText {
    color: #FFF;

    font-family: Helvetica;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 166.667% */
}

.nameInput {
    all: unset;
    color: #FFF;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.uploadIdBtnContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 27px;
    width: 80px;
    border-radius: 5px;
    border: 1px solid #FFF;
}

.uploadIdBtnText {
    color: #FFF;
    font-family: Helvetica;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}

.bottomText {
    color: #757575;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    text-transform: capitalize;
}
.submitBtnContainer{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 5vh;
    background-color: #4DCBCA;
    border-radius: 32px;
    padding: 15px 0px;
    cursor: pointer;
    box-sizing: border-box;
}
.submitBtn{
    all: unset;
    color: #FFF;
    font-family: Helvetica;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}

@media (max-width: 1640px) {
    .nameInput {
        font-size: 18px;
    }
    .uploadIconContainer {
        padding: 9px 23px;
    }
    .uploadImage{
        width: 18px;
        height: 18px;
    }
    .uploadIdBtnContainer {
        height: 25px;
        width: 75px;
    }
    .uploadIdBtnText {
        font-size: 10px;
        line-height: 15px;
    }
    .bottomText {
        font-size: 10px;
        line-height: 15px;
    }
}

@media (max-width: 1440px) {
    .nameInput {
        font-size: 16px;
    }
    .uploadIconContainer {
        padding: 8px 20px;
    }
    .uploadImage{
        width: 16px;
        height: 16px;
    }
    .uploadIdBtnContainer {
        height: 23px;
        width: 70px;
    }
    .uploadIdBtnText {
        font-size: 10px;
        line-height: 15px;
    }
    .bottomText {
        font-size: 10px;
        line-height: 15px;
    }
}
@media (max-width: 1280px) {
    .nameInput {
        font-size: 14px;
    }
    .uploadIconContainer {
        padding: 7px 18px;
        border-radius: 8px;
    }
    .uploadImage{
        width: 14px;
        height: 14px;
    }
    .uploadIdBtnContainer {
        height: 21px;
        width: 65px;
    }
    .uploadIdBtnText {
        font-size: 9px;
        line-height: 13px;
    }
    .bottomText {
        font-size: 8px;
        line-height: 12px;
    }
}
@media (max-width: 1024px) {
    .nameInput {
        font-size: 12px;
    }
    .uploadIconContainer {
        padding: 6px 15px;
        border-radius: 8px;
    }
    .uploadImage{
        width: 12px;
        height: 12px;
    }
    .uploadIdBtnContainer {
        height: 20px;
        width: 60px;
    }
    .uploadIdBtnText {
        font-size: 8px;
        line-height: 15px; 
        border-radius: 3px;
    }
    .bottomText {
        font-size: 8px;
        line-height: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/EditName/EditName.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;IAC3C,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;;IAEX,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,cAAc;QACd,iBAAiB;IACrB;IACA;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ","sourcesContent":[".editNameContainer {\n    width: 90%;\n    padding-left: 4vw;\n    padding-top: 5vh;\n    display: flex;\n    flex-direction: column;\n    gap: 5vh;\n    padding-bottom: 30px;\n}\n\n.uploadIdContainer {\n    border-radius: 20px;\n    background: #0E1B1B;\n    padding-left: 2vw;\n    box-sizing: border-box;\n    width: 90%;\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n.uploadIdContainer2 {\n    border-radius: 20px;\n    background: rgba(255, 255, 255, 0.10);\n    backdrop-filter: blur(25.989974975585938px);\n    width: 92%;\n    padding-left: 30px;\n    padding-top: 30px;\n    padding-bottom: 30px;\n    margin-top: 2vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: 18vh;\n    gap: 1vh;\n}\n\n.uploadIconContainer {\n    background-color: #4DCBCA;\n    border-radius: 10px;\n    padding: 10px 25px;\n}\n.uploadImage{\n    width: 20px;\n    height: 20px;\n}\n.uploadIdBtnText {\n    color: #FFF;\n\n    font-family: Helvetica;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    /* 166.667% */\n}\n\n.nameInput {\n    all: unset;\n    color: #FFF;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.uploadIdBtnContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 27px;\n    width: 80px;\n    border-radius: 5px;\n    border: 1px solid #FFF;\n}\n\n.uploadIdBtnText {\n    color: #FFF;\n    font-family: Helvetica;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n.bottomText {\n    color: #757575;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    text-transform: capitalize;\n}\n.submitBtnContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    height: 5vh;\n    background-color: #4DCBCA;\n    border-radius: 32px;\n    padding: 15px 0px;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n.submitBtn{\n    all: unset;\n    color: #FFF;\n    font-family: Helvetica;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n@media (max-width: 1640px) {\n    .nameInput {\n        font-size: 18px;\n    }\n    .uploadIconContainer {\n        padding: 9px 23px;\n    }\n    .uploadImage{\n        width: 18px;\n        height: 18px;\n    }\n    .uploadIdBtnContainer {\n        height: 25px;\n        width: 75px;\n    }\n    .uploadIdBtnText {\n        font-size: 10px;\n        line-height: 15px;\n    }\n    .bottomText {\n        font-size: 10px;\n        line-height: 15px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .nameInput {\n        font-size: 16px;\n    }\n    .uploadIconContainer {\n        padding: 8px 20px;\n    }\n    .uploadImage{\n        width: 16px;\n        height: 16px;\n    }\n    .uploadIdBtnContainer {\n        height: 23px;\n        width: 70px;\n    }\n    .uploadIdBtnText {\n        font-size: 10px;\n        line-height: 15px;\n    }\n    .bottomText {\n        font-size: 10px;\n        line-height: 15px;\n    }\n}\n@media (max-width: 1280px) {\n    .nameInput {\n        font-size: 14px;\n    }\n    .uploadIconContainer {\n        padding: 7px 18px;\n        border-radius: 8px;\n    }\n    .uploadImage{\n        width: 14px;\n        height: 14px;\n    }\n    .uploadIdBtnContainer {\n        height: 21px;\n        width: 65px;\n    }\n    .uploadIdBtnText {\n        font-size: 9px;\n        line-height: 13px;\n    }\n    .bottomText {\n        font-size: 8px;\n        line-height: 12px;\n    }\n}\n@media (max-width: 1024px) {\n    .nameInput {\n        font-size: 12px;\n    }\n    .uploadIconContainer {\n        padding: 6px 15px;\n        border-radius: 8px;\n    }\n    .uploadImage{\n        width: 12px;\n        height: 12px;\n    }\n    .uploadIdBtnContainer {\n        height: 20px;\n        width: 60px;\n    }\n    .uploadIdBtnText {\n        font-size: 8px;\n        line-height: 15px; \n        border-radius: 3px;\n    }\n    .bottomText {\n        font-size: 8px;\n        line-height: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
